const fetch = require('node-fetch');

const getDataFromUrl = async (url) => {
	let settings = { method: 'Get' };
	const res = await fetch(url, settings);
	return await res.json();
};

export default getDataFromUrl;
